import { useOrgStoreWithOut } from '/@/store/modules/org';
import { whiteNameList } from '/@/enums/pageEnum';
import { router } from '/@/router';

export function initChangeTab() {
  const orgStore = useOrgStoreWithOut();
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      if (
        !whiteNameList.includes(router.currentRoute.value.name) &&
        localStorage.getItem('orgId') &&
        orgStore.orgInfo?.id &&
        orgStore.orgInfo?.id !== localStorage.getItem('orgId')
      ) {
        location.href = router.resolve({ name: 'InvalidOrg' }).href;
      }
    }
  });
}
